import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { useAuth } from '../context/AuthContext';

export function DashboardPage() {
    const { t } = useTranslation();
    const { user, isSimulatedAuth } = useAuth();

    return (
        <>
            <PageSeo
                title={`Üye paneli — ${t('header.rotaryAlt')}`}
                description={t('seo.dashboard')}
                noindex
            />
            <SubpageLayout
                title="Üye paneli"
                subtitle="Yalnızca giriş yapmış üyelere açık alan"
                contentClassName="dashboard-page"
            >
            {isSimulatedAuth ? (
                <div
                    className="auth-simulation-notice mb-4"
                    role="status"
                    aria-live="polite"
                >
                    <strong>Simülasyon modu:</strong> Giriş gerçek bir sunucuya
                    bağlı değildir. Oturum bilgisi yalnızca bu tarayıcıda{' '}
                    <code className="auth-simulation-code">localStorage</code>{' '}
                    içinde tutulur. Canlı API için{' '}
                    <code className="auth-simulation-code">
                        src/config/authSimulation.js
                    </code>{' '}
                    dosyasındaki <code className="auth-simulation-code">
                        AUTH_MODE
                    </code>{' '}
                    ve <code className="auth-simulation-code">AuthContext</code>{' '}
                    güncellenir.
                </div>
            ) : null}
            <div className="dashboard-session-card">
                <p className="text-secondary mb-2 mb-sm-3">
                    Oturum açık kullanıcı:
                </p>
                <p className="dashboard-session-email mb-0">
                    {user?.email}
                    {user?.name ? (
                        <span className="dashboard-session-name text-secondary">
                            {' '}
                            ({user.name})
                        </span>
                    ) : null}
                </p>
            </div>
        </SubpageLayout>
        </>
    );
}
